<router-outlet></router-outlet>

<ngx-spinner bdColor="rgba(112,128,144, 0.5)">
</ngx-spinner>